import type { GetContractRevenueScheduleReportResponsePayload } from '@vy/api-definition';
import { GetContractRevenueScheduleReportResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useContractRevenueScheduleReport(
  contractId: string,
  options?: CustomUseQueryOptions<GetContractRevenueScheduleReportResponsePayload>,
) {
  return useQuery({
    queryKey: queryKeys.contractRevenueScheduleReport(contractId),
    queryFn: async () => {
      const api = getPrivateApi();
      const response = await api.getContractRevenueScheduleReport({ contractId });
      return GetContractRevenueScheduleReportResponseSchema.parse(response);
    },
    ...options,
  });
}
